import { Check, ClipboardList, RefreshCw } from 'lucide-react';

export function PriceBadge({ price, prefix = 'Starting at', testId, className = '' }) {
  return (
    <span className={`price-badge whitespace-nowrap ${className}`} data-testid={testId}>
      <span className="font-display text-[0.55rem] tracking-[0.3em] uppercase text-white/65 whitespace-nowrap">{prefix}</span>
      <span className="font-display text-xl sm:text-2xl font-bold text-white">{price}</span>
    </span>
  );
}

export function IncludesList({ label = 'Includes', items, cols = 1, testId }) {
  return (
    <div className="mt-5" data-testid={testId}>
      <p className="font-display text-[0.6rem] tracking-[0.35em] uppercase text-[#ffb37a]">{label}</p>
      <ul className={`mt-3 grid gap-x-6 gap-y-2 ${cols === 2 ? 'sm:grid-cols-2' : ''}`}>
        {items.map((it) => (
          <li key={it} className="flex items-start gap-2.5 text-sm text-white/85 leading-snug">
            <Check size={14} className="mt-0.5 shrink-0 text-[#ffb37a] drop-shadow-[0_0_6px_rgba(249,115,22,0.6)]" />
            <span>{it}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

// Gray "rainy cloud" note used for client requirements and revision policies.
export function RainNote({ kind = 'requirement', children, testId }) {
  const req = kind === 'requirement';
  const Icon = req ? ClipboardList : RefreshCw;
  return (
    <div className="glass-rain relative mt-5 rounded-2xl px-4 py-3.5" data-testid={testId}>
      <p className="flex items-center gap-2 font-display text-[0.58rem] tracking-[0.35em] uppercase rain-eyebrow">
        <Icon size={12} /> {req ? 'Client requirement' : 'Revision policy'}
      </p>
      <p className="mt-2 text-[0.8rem] leading-relaxed text-white/90">{children}</p>
    </div>
  );
}
